// https://redux-toolkit.js.org/tutorials/typescript#define-root-state-and-dispatch-types
import appSlice, { fetchBarchart } from 'web/app_slice';
import type { Region } from 'js/ebird/ebird';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
  },
});

// TODO: Proper needs region...
const needs: Region = { kind: 'county', code: 'US-WA-033', name: 'King' };
store.dispatch(appSlice.actions.setCurrentRegion(needs));
store.dispatch(fetchBarchart(needs.code));

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch;
